import React from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import qs from 'query-string';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import InfiniteScroll from 'react-infinite-scroller';
import Errors from 'components/shared/Errors';
import Main from 'components/templates/Main';
import Success from 'components/shared/Success';
import OrdersList from '../components/OrdersList';
import Dac7InfoContainer from '../../dac7/containers/Dac7InfoContainer';
import { fetchOrdersRequest, fetchOrdersSuccess } from '../redux/actionCreators';
import * as selectors from '../redux/selectors';

class OrdersListContainer extends React.Component {
  state = {
    type: '__none__',
    paid_at_from: null,
    paid_at_to: null,
    order: 'id DESC',
  };

  componentDidMount() {
    const params = qs.parse(this.props.location.search);
    this.setState(
      {
        ...this.state,
        ...params,
      },
      () => {
        this.fetchFirst();
      },
    );
  }

  componentWillUnmount() {
    this.resetList();
  }

  fetchFirst = (query = false) => {
    this.resetList();

    if (query) {
      const has = Object.keys(this.state).filter(
        (k) => this.state[k] && this.state[k] !== '__none__',
      );

      this.props.history.push({
        pathname: '/orders',
        search: qs.stringify(pick(this.state, has)),
      });
    }

    const filters = {
      order: this.state.order,
    };

    if (this.state.type && this.state.type !== '__none__') {
      filters[this.state.type.toLowerCase()] = 1;
    }

    if (this.state.paid_at_from) {
      filters.paid_at_from = this.state.paid_at_from;
    }

    if (this.state.paid_at_to) {
      filters.paid_at_to = this.state.paid_at_to;
    }

    this.props.fetchOrdersRequest({ limit: 10, offset: 0, ...filters });
  };

  resetList = () => {
    this.props.fetchOrdersSuccess({ nextPage: null, reset: true });
  };

  fetchMore = () => {
    const { nextPage } = this.props;
    this.props.fetchOrdersRequest({ nextPage });
  };

  changeFilter = (name) => (event) => {
    const { value } = event.target;

    this.setState({ [name]: value }, () => {
      this.fetchFirst(true);
    });
  };

  changePicker = (name) => (value) => {
    this.setState(
      {
        ...this.state,
        [name]: value ? value.toISOString() : null,
      },
      () => {
        this.fetchFirst(true);
      },
    );
  };

  render() {
    const { error, success, nextPage } = this.props;

    return (
      <Main title={<FormattedMessage id="Receipts" defaultMessage="Receipts" />}>
        <Dac7InfoContainer />
        <InfiniteScroll initialLoad loadMore={this.fetchMore} hasMore={!!nextPage} threshold={10}>
          <OrdersList
            {...this.props}
            changeFilter={this.changeFilter}
            changePicker={this.changePicker}
            filters={this.state}
            hasMore={!!nextPage}
          />
        </InfiniteScroll>
        <Success success={success} />
        <Errors errors={error} />
      </Main>
    );
  }
}

OrdersListContainer.propTypes = {
  error: PropTypes.shape({}),
  nextPage: PropTypes.string,
  success: PropTypes.shape({}),
  fetchOrdersRequest: PropTypes.func.isRequired,
  fetchOrdersSuccess: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

const mapStateToProps = (state) => ({
  error: selectors.error(state),
  isLoading: selectors.isLoading(state),
  list: selectors.list(state),
  nextPage: selectors.nextPage(state),
  success: selectors.success(state),
});

const mapDispatchToProp = {
  fetchOrdersRequest,
  fetchOrdersSuccess,
};

export default connect(mapStateToProps, mapDispatchToProp)(OrdersListContainer);
